import { EventType } from "@/analytics/analytics-events";
import { ExportToolClippingProperties } from "@/analytics/export-tool-events-properties";
import { ClippingBoxViewControls } from "@/components/ui/clipping-box-view-controls";
import { selectSelectedExportModeTab } from "@/store/modes/export-mode-selectors";
import { useAppSelector } from "@/store/store-hooks";
import { useBoxControlsContext } from "@/utils/box-controls-context";
import { Analytics } from "@faro-lotv/foreign-observers";
import { useMemo, type JSX } from "react";
import { ExportModeTab } from "./export-mode-types";

/**
 * @returns the overlay for the export mode
 */
export function ExportModeOverlay(): JSX.Element | null {
  const { autoBoxEvent, resetBoxEvent } = useBoxControlsContext();

  // Setup properties for analytics events
  const selectedTab = useAppSelector(selectSelectedExportModeTab);
  const via = useMemo<ExportToolClippingProperties["via"]>(() => {
    if (selectedTab === "pointCloud") {
      return "point cloud";
    }
    return "orthophoto";
  }, [selectedTab]);

  if (selectedTab === ExportModeTab.scans) {
    // No overlay for scans export tab required
    return null;
  }

  return (
    <ClippingBoxViewControls
      onResetBox={() => {
        Analytics.track<ExportToolClippingProperties>(
          EventType.exportResetClip,
          { via },
        );
        resetBoxEvent.emit();
      }}
      onFitBoxToView={() => {
        Analytics.track<ExportToolClippingProperties>(
          EventType.exportAutoClip,
          { via },
        );
        autoBoxEvent.emit();
      }}
    />
  );
}
